<header class="header">
  <app-menu></app-menu>
  <span class="header-title">{{headerTitle}}</span>
</header>
